import { MediaBox, Shimmer } from "@jewlr/storybook/core"
import React from "react"

import Badge from "areas/product/jewlr/wizard-header/badge"
import { IS_JEWLR } from "helpers/application"

import WizardPricingLoading from "./wizard-pricing-loading"

const WizardHeaderLoading = () => {
  return (
    <>
      {IS_JEWLR() && (
        <MediaBox greaterThanOrEqual="tablet">
          <Badge />
        </MediaBox>
      )}
      <Shimmer
        borderRadius="4px"
        height={{ _: "42px", tablet: "28px" }}
        mb={1}
        width={{ _: "100%", tablet: "320px" }}
      />
      <WizardPricingLoading />
      {IS_JEWLR() && (
        <Shimmer
          borderRadius="4px"
          height={
            sl.config.klarna_osm_pdp ? { _: "38px", tablet: "21px" } : "18px"
          }
          width="100%"
        />
      )}
    </>
  )
}

export default WizardHeaderLoading
